import * as React from "react";
import { useToggle } from "react-use";
import { UserModal } from "./userModal";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { createBase64Image, defaultUserAvatar } from "@/helpers/images";
import { Userdata } from "@/types/user";

interface Props {
  user: Userdata;
}

export const UsersTableRow: React.FC<Props> = ({ user }) => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  return (
    <tr>
      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
        <Avatar className="mr-2 h-6 w-6">
          <AvatarImage
            src={user.avatar ? createBase64Image(user.avatar, "png") : defaultUserAvatar}
            alt={user.username}
          />
          <AvatarFallback>{user.username?.[0]?.toUpperCase() || "U"}</AvatarFallback>
        </Avatar>
      </td>

      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
        {user.name} {user.surname}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.username}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.email}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.phoneNumber}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.isActive ? "Yes" : "No"}</td>
      <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
        {isOpen && <UserModal user={user} isOpen={isOpen} setIsOpen={toggleIsOpen} />}

        <button onClick={toggleIsOpen} type="button" className="text-primary">
          Edit<span className="sr-only">, {user.username}</span>
        </button>
      </td>
    </tr>
  );
};
